<template>
  <div id="leaseIndex" class="dashboard-editor-container">
    <el-row id="tableWarp">
      <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
        <!-- 列表 -->
        <div style="position: relative;padding:10px 20px 20px;">
          <div id="filter" style="margin-top:20px;">
            <div style="display: fixed;">
              <el-input v-model="tableObj.deviceName" :placeholder="$t('dashboard.DeviceName')" clearable class="input-with-select deviceNameTable" @clear="changeSearch(tableObj.deviceName)">
                <el-button slot="append" icon="el-icon-search" @click="changeSearch(tableObj.deviceName)" />
              </el-input>
              <el-input v-model="tableObj.yhubSn" placeholder="Y-Hub SN" clearable class="input-with-select deviceNameTable" @clear="changeSearch(tableObj.yhubSn)">
                <el-button slot="append" icon="el-icon-search" @click="changeSearch(tableObj.yhubSn)" />
              </el-input>
              <el-input v-if="!showMachineTable" v-model="tableObj.customerName" :placeholder="$t('lease.Customer')" clearable class="input-with-select deviceNameTable" @clear="changeSearch(tableObj.customerName)">
                <el-button slot="append" icon="el-icon-search" @click="changeSearch(tableObj.customerName)" />
              </el-input>
              <el-button v-if="showMachineTable&&$store.state.userInfo.guestFlag!=true" :title="$t('titles.addDeviceInfo')" type="primary" icon="el-icon-plus" style="float: right;margin-bottom: 10px;" @click="initPop('','add')" />
            </div>
          </div>
          <el-tabs v-model="activeName" style="margin-top:15px;" type="border-card">
            <el-tab-pane :label="$t('lease.DeviceInformation')" name="machineInfo">
              <div>
                <el-table :data="machineTableData" style="width: 100%;padding:2px;" border @sort-change="sortChange">
                  <el-table-column prop="deviceSn" :label="$t('lease.machineSN')">
                    <template slot-scope="scope">
                      <span>{{ scope.row.deviceSn }}</span>
                      <div style="display: inline-block;float: right;">
                        <!-- <el-button type="primary" icon="el-icon-edit " size="mini" @click="initPop(scope.row)" /> -->
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="deviceName" :label="$t('dashboard.DeviceName')">
                    <template slot-scope="scope">
                      <el-link type="primary" @click="goToDetailgPage(scope.row)">
                        {{ scope.row. deviceName }}
                      </el-link>
                    </template>
                  </el-table-column>
                  <el-table-column prop="yhubSn" label="Y-Hub SN" />
                  <el-table-column prop="customerName" :label="$t('lease.Customer')" />
                  <el-table-column prop="endTime" :label="$t('lease.ExpireOn')" align="center" />
                  <el-table-column prop="status" :label="$t('AllDevices.Status')" align="center">
                    <template slot-scope="scope">
                      <div style="text-align: center;">
                        <div class="statusDiv">
                          <div v-if="scope.row.statusDiv=='green'" class="greenStatus" />
                          <div v-if="scope.row.statusDiv=='yellow'" class="yellowStatus" />
                          <div v-if="scope.row.statusDiv=='red'" class="redStatus" />
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="totalDays" :label="$t('lease.TotalRentedDays')" />
                  <el-table-column prop="totalCost" :label="$t('lease.TotalIncome')" />
                  <el-table-column prop="relayStatus" :label="$t('lease.LockedState')">
                    <template slot-scope="scope">
                      <p v-if="scope.row.relayStatus==1">{{ $t('lease.Locked') }}</p>
                      <p v-else>{{ $t('lease.NotLocked') }}</p>
                    </template>
                  </el-table-column>
                  <el-table-column prop="status" :label="$t('yhubReport.Operating')" align="center" width="150px">
                    <template slot-scope="scope">
                      <el-button v-if="$store.state.userInfo.guestFlag!=true" type="primary" icon="el-icon-edit" :title="$t('titles.edit')" size="mini" @click="initPop(scope.row,'edit')" />
                      <el-button v-if="$store.state.userInfo.guestFlag!=true" type="primary" icon="el-icon-delete" :title="$t('titles.delete')" size="mini" @click="deletePop(scope.row)" />
                    </template>
                  </el-table-column>
                </el-table>
                <!-- 列表模块————分页 -->
                <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
                  <div class="pagination-container">
                    <el-pagination
                      v-if="pageshow1"
                      background
                      current-page.sync="listQuery1.pageInfo.page"
                      :page-sizes="listQuery1.pageInfo.pageList"
                      :page-size="listQuery1.pageInfo.limit"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="listQuery1.pageInfo.total"
                      @size-change="handleSizeChange1"
                      @current-change="handleCurrentChange1"
                    />
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('lease.LeaseInformation')" name="leaseInfo">
              <div>
                <el-table :data="leaseTableData" style="width: 100%;padding:2px;" border @sort-change="sortChange">
                  <el-table-column prop="customerName" :label="$t('lease.Customer')" />
                  <el-table-column prop="endTime" :label="$t('lease.ExpireOn')" sortable align="center" />
                  <el-table-column prop="status" :label="$t('AllDevices.Status')" align="center">
                    <template slot-scope="scope">
                      <div style="text-align: center;">
                        <div class="statusDiv">
                          <div v-if="scope.row.statusDiv=='green'" class="greenStatus" />
                          <div v-if="scope.row.statusDiv=='yellow'" class="yellowStatus" />
                          <div v-if="scope.row.statusDiv=='red'" class="redStatus" />
                          <div v-if="scope.row.statusDiv=='gray'" class="grayStatus" />
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="days" :label="$t('lease.RentedDays')" />
                  <el-table-column prop="cost" :label="$t('lease.Income')" />
                  <el-table-column prop="deviceSn" :label="$t('lease.machineSN')">
                    <template slot-scope="scope">
                      <span>{{ scope.row.deviceSn }}</span>
                      <div style="display: inline-block;float: right;">
                        <!-- <el-button type="primary" icon="el-icon-edit " size="mini" @click="initPop(scope.row)" /> -->
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="deviceName" :label="$t('dashboard.DeviceName')">
                    <template slot-scope="scope">
                      <el-link type="primary" @click="goToDetailgPage(scope.row)">
                        {{ scope.row. deviceName }}
                      </el-link>
                    </template>
                  </el-table-column>
                  <el-table-column prop="yhubSn" label="Y-Hub SN" />
                </el-table>
                <!-- 列表模块————分页 -->
                <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
                  <div class="pagination-container">
                    <el-pagination
                      v-if="pageshow2"
                      background
                      current-page.sync="listQuery2.pageInfo.page"
                      :page-sizes="listQuery2.pageInfo.pageList"
                      :page-size="listQuery2.pageInfo.limit"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="listQuery2.pageInfo.total"
                      @size-change="handleSizeChange2"
                      @current-change="handleCurrentChange2"
                    />
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-col>
    </el-row>
    <!-- 新增/编辑--弹窗 -->
    <el-dialog id="leasePopId" :close-on-click-modal="false" :visible.sync="isShowPop" width="40%">
      <el-form ref="leasePop" :model="popData" label-position="right" label-width="180px" :inline="false" :rules="popRule">
        <el-form-item :label="$t('lease.machineSN')" prop="deviceSnPop" class="deviceSnPop redStart">
          <!-- <el-select v-model="popData.deviceSn" :placeholder="$t('BondOrUpdateDevice.PleaseEnterSN')" class="filter-item" filterable clearable @change="selectSn">
            <el-option v-for="item in yhubSnOptionsPop" :key="item" :label="item" :value="item" />
          </el-select> -->
          <el-input v-model="popData.deviceSnPop" @input="change($event)" />
        </el-form-item>
        <el-form-item :label="$t('dashboard.DeviceName')" prop="deviceNamePop">
          <el-input v-model="popData.deviceNamePop" @input="change($event)" />
        </el-form-item>
        <el-form-item label="Y-Hub SN" prop="mm">
          <!-- <el-input v-model="popData.yhubSn" @input="change($event)" /> -->
          <el-select v-model="popData.yhubSn" :placeholder="$t('BondOrUpdateDevice.PleaseEnterSN')" class="filter-item" filterable clearable @change="selectSn">
            <el-option v-for="item in yhubSnOptionsPop" :key="item" :label="item" :value="item" />
          </el-select>
          <!-- <p v-show="isShowSnWarn" class="redWarningFont">{{ $t('BondOrUpdateDevice.SNNotFound') }}</p> -->
        </el-form-item>
        <el-form-item :label="$t('warningPage.Remark')" prop="mm">
          <el-input v-model="popData.remark" type="textarea" style="width: 80%" :autosize="{ minRows: 4, maxRows: 8}" @input="change($event)" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="display: flex;justify-content: flex-end;">
        <el-button @click="isShowPop=false">{{ $t('button.Cancel') }}</el-button>
        <el-button class="filter-item" type="primary" @click="confirmPop('leasePop')">{{ $t('button.Confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listRentalDevice, addRentalDevice, updateRentalDevice, findSnList, pageRentalDeviceDetail, deleteRentalDevice, updateGnssGeofenceStatus } from '@/api/leaseManagement'
// import gMap from '@/components/gmap'// 高德和谷歌地图
import { pagination } from '@/utils/init_table' // 分页
import { getDateAndHour } from '@/utils/updateTime.js'
import i18n from '@/i18n'
import PieChartCici from '@/components/pieChart'
import lineChartTwo from '@/components/lineChartTwo'

export default {
  name: 'DashboardAdmin',
  components: {},
  data() {
    return {
      // 分页----start
      listQuery1: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow1: true,
      // 分页----end
      // 分页----start
      listQuery2: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow2: true,
      // 分页----end
      machineTableData: [],
      tableObj: {
        deviceName: '', // 删选--设备名称/sn/mcuId
        selectDate: '', // 删选--时间：bondTime/updateTime
        order: '', // 删选--排序方式：'ascending' or 'descending'
        selectCompany: [], // 删选--公司
        selectElectricFence: -1// 删选--电子围栏开关
      },
      isShowPop: false,
      popData: {},
      popRule: {
        deviceSnPop: [{ required: true, message: i18n.t('lease.Cannotbeblanked'), trigger: 'blur' }], // 序列号不能为空
        deviceNamePop: [{ required: true, message: i18n.t('BondOrUpdateDevice.PleaseEnterAName'), trigger: 'blur' }] // 设备名称不能为空
      },
      yhubSnOptionsPop: [],
      isShowSnWarn: false,
      activeName: 'machineInfo',
      showMachineTable: true,
      tabMapOptions: [
        { label: i18n.t('lease.DeviceInformation'), key: 'machineInfo' },
        { label: i18n.t('lease.LeaseInformation'), key: 'leaseInfo' }
      ],
      leaseTableData: [],
      isAdd: null
    }
  },
  computed: {
    language() {
      return this.$store.state.language
    }
  },
  watch: {
    activeName: {
      handler(newValue, oldValue) {
        if (newValue == 'machineInfo') {
          this.showMachineTable = true
          this.queryMachine()
        } else {
          this.showMachineTable = false
          this.queryLease()
        }
      },
      deep: true
    }
  },
  mounted() {
    this.queryMachine()
    this.queryLease()
    this.initPopSn()
  },
  created() {},
  methods: {
    queryMachine() {
      var param = {
        'companyIdList': [],
        'customerName': this.tableObj.customerName,
        'deviceName': this.tableObj.deviceName,
        'deviceSn': '',
        'orderBy': this.tableObj.order,
        'pageNum': this.listQuery1.pageInfo.pageNum,
        'pageSize': this.listQuery1.pageInfo.pageSize,
        'yhubSn': this.tableObj.yhubSn
      }
      listRentalDevice(param).then(res => {
        if (res.resultCode == 1001) {
          this.machineTableData = res.resultModel.list // 列表数据
          // this.machineTableData = [
          //   { machineNum: '123456789', deviceName: 'GHSGJSODJ', yhubSn: '012123231', leaseCompany: 'GPD', createTime: '1582188473000', status: '1', totalRentalTime: '212天', totalIncome: '1323', opration: '1' },
          //   { machineNum: '123456789', deviceName: 'GHSGJSODJ', yhubSn: '012123231', leaseCompany: 'GPD', createTime: '1582188473000', status: '1', totalRentalTime: '212天', totalIncome: '1323', opration: '1' },
          //   { machineNum: '123456789', deviceName: 'GHSGJSODJ', yhubSn: '012123231', leaseCompany: 'GPD', createTime: '1582188473000', status: '1', totalRentalTime: '212天', totalIncome: '1323', opration: '1' },
          //   { machineNum: '123456789', deviceName: 'GHSGJSODJ', yhubSn: '012123231', leaseCompany: 'GPD', createTime: '1582188473000', status: '1', totalRentalTime: '212天', totalIncome: '1323', opration: '1' },
          //   { machineNum: '123456789', deviceName: 'GHSGJSODJ', yhubSn: '012123231', leaseCompany: 'GPD', createTime: '1582188473000', status: '1', totalRentalTime: '212天', totalIncome: '1323', opration: '1' },
          //   { machineNum: '123456789', deviceName: 'GHSGJSODJ', yhubSn: '012123231', leaseCompany: 'GPD', createTime: '1582188473000', status: '1', totalRentalTime: '212天', totalIncome: '1323', opration: '1' },
          //   { machineNum: '123456789', deviceName: 'GHSGJSODJ', yhubSn: '012123231', leaseCompany: 'GPD', createTime: '1582188473000', status: '1', totalRentalTime: '212天', totalIncome: '1323', opration: '1' },
          //   { machineNum: '123456789', deviceName: 'GHSGJSODJ', yhubSn: '012123231', leaseCompany: 'GPD', createTime: '1582188473000', status: '1', totalRentalTime: '212天', totalIncome: '1323', opration: '1' }
          // ]
          this.listQuery1.pageInfo.total = res.resultModel.total // 分页
          this.machineTableData.forEach((v, i) => {
            if (v.status == 2) { // 1:有效；2：无效
              this.machineTableData[i].statusDiv = 'gray'
            } else if (v.status == 1) { // 1:有效；2：无效
              if (v.endTime) {
                var time = v.endTime - new Date().getTime()
                if (time > 14 * 24 * 60 * 60 * 1000) { // 大于2周
                  this.machineTableData[i].statusDiv = 'green'
                } else if (time > 0) { // 未到期
                  this.machineTableData[i].statusDiv = 'yellow'
                } else { // 过期
                  this.machineTableData[i].statusDiv = 'red'
                }
              }
            }
            v.endTime = getDateAndHour(v.endTime, 'noTime')
          })
        }
      })
    },
    queryLease() {
      var param = {
        'companyIdList': [],
        'customerName': this.tableObj.customerName,
        'deviceName': this.tableObj.deviceName,
        'deviceSn': '',
        'orderBy': this.tableObj.order2,
        'pageNum': this.listQuery2.pageInfo.pageNum,
        'pageSize': this.listQuery2.pageInfo.pageSize,
        'yhubSn': this.tableObj.yhubSn
      }
      pageRentalDeviceDetail(param).then(res => {
        if (res.resultCode == 1001) {
          this.leaseTableData = res.resultModel.list // 列表数据
          this.listQuery2.pageInfo.total = res.resultModel.total // 分页
          this.leaseTableData.forEach((v, i) => {
            if (v.status == 2) { // 1:有效；2：无效
              this.leaseTableData[i].statusDiv = 'gray'
            } else if (v.status == 1) { // 1:有效；2：无效
              if (v.endTime) {
                var time = v.endTime - new Date().getTime()
                if (time > 14 * 24 * 60 * 60 * 1000) { // 大于2周
                  this.leaseTableData[i].statusDiv = 'green'
                } else if (time > 0) { // 未到期
                  this.leaseTableData[i].statusDiv = 'yellow'
                } else { // 过期
                  this.leaseTableData[i].statusDiv = 'red'
                }
              }
            }
            v.endTime = getDateAndHour(v.endTime, 'noTime')
          })
        }
      })
    },
    initPop(row, val) { // 弹窗--初始化
      this.isShowPop = true
      if (row) {
        console.log(row)
        this.popData = {
          deviceSnPop: row.deviceSn,
          deviceNamePop: row.deviceName,
          yhubSn: row.yhubSn,
          remark: row.remark,
          id: row.id
        }
      } else {
        for (var attr in this.popData) this.popData[attr] = ''
      }
      this.isAdd = val == 'add' ? 'true' : 'false'
    },
    deletePop(row) { // 删除设备
      this.$confirm(i18n.t('lease.deleteDevice'), '', {// 确定删除设备吗？
        confirmButtonText: i18n.t('button.Confirm'), // '确定'
        cancelButtonText: i18n.t('button.Cancel'),
        type: 'warning'
      }).then(() => {
        deleteRentalDevice({ id: row.id }).then(res => {
          if (res.resultCode == 1001) {
            this.queryMachine()
            this.$message({
              type: 'success',
              message: i18n.t('lease.Succeed')
            })
          }
        })
      }).catch(() => {})
    },
    initPopSn() { // 弹窗--sn初始化
      // 不传公司id，因为传了则只返回当前公司下的数据，不传则默认返回当前登录账号公司及其子公司的数据
      // findSnList({ 'companyIdList': [this.$store.state.companyId] }).then(res => {
      findSnList({ 'companyIdList': [] }).then(res => {
        if (res.resultCode == 1001) {
          this.yhubSnOptionsPop = res.resultModel
        }
      })
    },
    selectSn() { // 弹窗--选择sn
      this.isShowSnWarn = false
    },
    confirmPop(formName) { // 弹窗--提交
      var param = {
        'deviceSn': this.popData.deviceSnPop,
        'deviceName': this.popData.deviceNamePop,
        'yhubSn': this.popData.yhubSn,
        'remark': this.popData.remark
      }
      // if (!this.popData.deviceSn) {
      //   this.isShowSnWarn = true
      //   return
      // }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isAdd == 'true') { // 新增
            addRentalDevice(param).then(res => {
              if (res.resultCode == 1001) {
                this.isShowPop = false
                this.queryMachine()
                this.$message({
                  type: 'success',
                  message: i18n.t('warningSet.submitted')
                })
              } else {
                this.$message({
                  type: 'error',
                  message: i18n.t('lease.Failed')
                })
              }
            })
          } else { // 编辑
            param.id = this.popData.id
            updateRentalDevice(param).then(res => {
              if (res.resultCode == 1001) {
                this.isShowPop = false
                this.queryMachine()
                this.$message({
                  type: 'success',
                  message: i18n.t('warningSet.submitted')
                })
              } else {
                this.$message({
                  type: 'error',
                  message: i18n.t('lease.Failed')
                })
              }
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    goToDetailgPage(row) { // to详情页
      var routeData = this.$router.resolve({
        path: '/leaseMagt/leaseMagtDetail',
        query: {
          id: row.rentalDeviceId ? row.rentalDeviceId : row.id,
          deviceSn: row.deviceSn,
          deviceName: row.deviceName,
          yhubSn: row.yhubSn
        }
      })
      window.open(routeData.href, '_self')
    },
    change(e) {
      this.$forceUpdate()
    },
    sortChange(column) { // order: descending(降序)/ascending(升序)/null
      // 后台：1:endTimeDesc/2:endTimeAsc
      console.log(column)
      if (column.order == 'descending') this.tableObj.order2 = 1
      if (column.order == 'ascending') this.tableObj.order2 = 2
      // this.tableObj.order = column.order
      this.queryLease()
    },
    // 筛选改变事件
    changeSearch(inputDevName) {
      // 去掉首尾空格
      if (this.tableObj.deviceName) this.tableObj.deviceName = this.tableObj.deviceName.replace(/(^\s*)|(\s*$)/g, '').replace(/(^\&nbsp\;*)|(\&nbsp\;*$)/g, '').replace(/(^\s*)|(\s*$)/g, '')
      if (this.tableObj.yhubSn) this.tableObj.yhubSn = this.tableObj.yhubSn.replace(/(^\s*)|(\s*$)/g, '').replace(/(^\&nbsp\;*)|(\&nbsp\;*$)/g, '').replace(/(^\s*)|(\s*$)/g, '')
      if (this.tableObj.customerName) this.tableObj.customerName = this.tableObj.customerName.replace(/(^\s*)|(\s*$)/g, '').replace(/(^\&nbsp\;*)|(\&nbsp\;*$)/g, '').replace(/(^\s*)|(\s*$)/g, '')
      if (this.activeName == 'machineInfo') {
        this.listQuery1.pageInfo.pageNum = 1
        this.pageshow1 = false
        this.queryMachine()
        this.$nextTick(() => {
          this.pageshow1 = true
        })
      } else {
        this.listQuery2.pageInfo.pageNum = 1
        this.pageshow2 = false
        this.queryLease()
        this.$nextTick(() => {
          this.pageshow2 = true
        })
      }
    },
    // 分页----start
    handleSizeChange1(val, e) { // 每一页的列表的行数 10 20 50
      this.listQuery1.pageInfo.pageSize = val
      this.queryMachine()
    },
    handleCurrentChange1(val, e) { // 选中某一页
      this.listQuery1.pageInfo.pageNum = val
      this.queryMachine()
    },
    // 分页----end
    // 分页----start
    handleSizeChange2(val, e) { // 每一页的列表的行数 10 20 50
      this.listQuery2.pageInfo.pageSize = val
      this.queryLease()
    },
    handleCurrentChange2(val, e) { // 选中某一页
      this.listQuery2.pageInfo.pageNum = val
      this.queryLease()
    }
    // 分页----end
  }
}
</script>

<style lang="scss" scoped>
p{
  margin:0
}
#leaseIndex{
  height:100%;
  background: #fff;
  .statusDiv{
    width:100%;
    height: 20px;
    background:#f3f3f3;
    margin-top:2px;
  }
  .grayStatus{
    width: 100%;
    background: #f3f3f3;
    height: 20px;
  }
  .greenStatus{
    width: 33%;
    background: #43d043;
    height: 20px;
  }
  .yellowStatus{
    width: 66%;
    background: #f7f73f;
    height: 20px;
  }
  .redStatus{
    width: 100%;
    background: #fb2b2b;
    height: 20px;
  }
}
</style>
<style lang="scss">
#leaseIndex{
  .el-table th.gutter{
    display: table-cell!important;
  }
  .el-button--mini {
    // padding: 3px 10px;
  }
  .cell span{
    margin-top: 2px;
    display: inline-block;
  }
  #leasePopId{
    .el-autocomplete,.el-cascader--medium,.el-input,.deviceSnPop .el-select{
      width:80%!important;
    }
    // .deviceSnPop .el-input{
    //   width:100%!important;
    // }
    .el-select.filter-item.el-select--medium{
      width:100%!important;
    }
  }
  #filter{
    .el-input-group {
      width: 20%;
    }
  }

}
</style>
